import React from 'react'
import { Head } from '../../components/Head'
import { SnackTitle } from '../../components/SnackTitle'
import { Snacks } from '../../components/Snacks'
import { useSnack } from '../../hooks/useSnack'

export default function IceCreamPage() {
  const { iceCreams } = useSnack()
  return (
    <>
      <Head title='Hambúrggers' description='Nossos melhores burggers' />
      <SnackTitle>Sorvets</SnackTitle>
      <Snacks snacks={iceCreams} />
    </>
  )
}
